import { FaShoppingBag, FaHandSparkles, FaThumbsUp, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaShoppingBag />, // Shopping bag icon
    title: 'Orders Completed',
    count: '5000',
  },
  {
    id: 2,
    icon: <FaHandSparkles />, // Hand sparkles icon
    title: 'Services Offered',
    count: '15',
  },
  {
    id: 3,
    icon: <FaThumbsUp />, // Thumbs-up icon
    title: 'Satisfied Customers',
    count: '1000',
  },
  {
    id: 4,
    icon: <FaMapMarkerAlt />, // Map marker icon
    title: 'Locations Served',
    count: '5',
  },
];

export default counter;